export default __webpack_public_path__ + "static/media/contactus.74c87cd9.svg";